import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_DATA_FIELDS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
} from "../constants";
import { BriefService } from "../services/brief.service";

interface IDeleteBriefDataFieldRequest {
  briefId: string;
  customFieldId: string;
}

export function useDeleteBriefDataField(briefId: string) {
  const {
    mutate: deleteDataField,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation({
    mutationFn: (data: IDeleteBriefDataFieldRequest) =>
      BriefService.deleteBriefDataFieldV2(
        data.briefId,
        data.customFieldId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, briefId],
      });

      const briefQueryKey = [...BRIEF_LIST_QUERY_KEY, briefId];

      c.setQueryData(briefQueryKey, data);
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        refetchType: "all",
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, briefId],
      });
    },
  });

  return {
    deleteDataField,
    isDeleting,
    isDeleted,
    deleteDataFieldVariables: variables,
  };
}
